<template>
  <div class="common__pageBody__1Dn3a" style="">
    <div class="style__active_details__2eC8m" style="font-size: 0px">
      <!-- <div class="style__banner__1r7BT"><img :src="dataInfo.banner" class="style__main_pic__2m4D_" style="" /></div> -->
      <div class="style__main_bg__FZhzx" >
        <div class="style__content_container__1gl64">
   
          <section class="recommendGame__container__3Usd1"><img :src="dataInfo.banner" class="recommendGame__page_pic__2FLT9" style="" /></section>
          <div>
            <section class="style__common_container__apSU5" style="background-image: url('undefined'); background-size: cover; background-repeat: no-repeat">
              <div class="style__common_main__2-cmI">
                <img src="/static/image/rule_title.f0067853f2128510b0fa1d3926bdc28d.svg" width="168px" class="style__title__1ZEmt" />
                <div class="style__content_wrapper__1wmO9">
                  <div class="style__content__uU_Dt">
                    <div v-html="dataInfo.content" style="padding:20px 0"></div>
                    <div class="style__rule_content__1t2-x" v-html="dataInfo.memo">
                     
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="style__entry__LyKjA" @click="doactivityapply" v-if="$store.state.token">
        <div class="activity-entry__floatIn__1t39T" style="width: 120px; height: 120px"><img class="activity-entry__entryImg__2Y5SL" src="/static/image/f0023def5a9a49c0a85868a4bbab3546.gif" alt="" /></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activityInfo',
  data() {
    return {dataInfo: {}};
  },
  created() {
    let that = this;
           let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
      getInfo(id) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    doactivityapply() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id }).then(res => {
        that.$parent.hideLoading();
        that.$parent.showTost(1, res.message);
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/RacePage_793450d6.6a5dc3c2.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/activityInfo.vue